interface DistressProps {
  onNavigate: (to: string) => void;
}

interface GameEntry {
  slug: string;
  name: string;
  blurb: string;
  ready: boolean;
}

const GAMES: readonly GameEntry[] = [
  {
    slug: "flashcards",
    name: "Identify the distress signal",
    blurb:
      "See a signal description, pick which Annex IV signal it is. Drills the non-flag distress repertoire — flares, smoke, SART, dye, arms wave.",
    ready: true,
  },
];

export function Distress({ onNavigate }: DistressProps) {
  return (
    <>
      <p className="muted">
        IRPCS <strong>Annex IV</strong> — distress signals other than the
        NC flag hoist. The full catalogue, grouped by type with when each
        is used, lives on the Reference tab; drill recognition in the
        flashcards below.
      </p>

      <h2 style={{ marginTop: 24 }}>Games</h2>
      {GAMES.map((g) => (
        <div key={g.slug} className="card">
          <h3 style={{ marginBottom: 4 }}>{g.name}</h3>
          <p className="small muted" style={{ marginBottom: 12 }}>
            {g.blurb}
          </p>
          <button
            onClick={() => onNavigate(`/play/distress/${g.slug}`)}
            className="secondary"
          >
            Play
          </button>
        </div>
      ))}

      <button className="secondary" onClick={() => onNavigate("/play")}>
        ← Back to Play
      </button>
    </>
  );
}
